import { render, staticRenderFns } from "./Partner_Dashboard.vue?vue&type=template&id=bad5aa00&scoped=true&"
import script from "./Partner_Dashboard.vue?vue&type=script&lang=js&"
export * from "./Partner_Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Partner_Dashboard.vue?vue&type=style&index=0&id=bad5aa00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad5aa00",
  null
  
)

export default component.exports